import Constants from 'arts/config/constants';

export const disallow = () => ({ type: Constants.MailSubscriptions.DISALLOW });
